/**
 * Entry points into translation from other screens: the product, category,
 * page, post, menu and email editors, onboarding and the order detail.
 * Conventions: see `common.ts`.
 */
const i18nEntry: Record<string, string> = {
  translate: 'Translate',
  translate_item: 'Translate {label}',
  language_label: '{native} ({name})',

  'card.title': 'Translations',
  'card.description': 'How much of this item is translated into each of your store languages.',
  'card.original': 'Original',
  'card.translate_into': 'Translate into {language}',
  'card.open_editor': 'Open translation editor',

  'onboarding.store_language': 'Store language',
  'onboarding.store_language_hint':
    'The language your storefront opens in. You can change it later in Settings → Languages.',
  'onboarding.additional_languages': 'Additional languages (optional)',
  'onboarding.additional_languages_hint':
    'Shoppers can switch to these. How many languages you can publish depends on your plan.',

  'order.checkout_language': 'Checkout language: {language}',
};

export default i18nEntry;
